export const isValidEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(email);
};

export const isValidDate = (year, month, date) => {
    // Check that all values are integers
    let _year = parseInt(year, 10);
    let _month = parseInt(month, 10);
    let _date = parseInt(date, 10);

    if (isNaN(_year) || isNaN(_month) || isNaN(_date)) {
        return false;
    }


    if (_year < 1900 || _year > (new Date()).getFullYear() || _month <= 0 || _month > 12) {
        return false;
    }

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Leap year
    if (_year % 400 === 0 || (_year % 100 !== 0 && _year % 4 === 0)) {
        monthLength[1] = 29;
    }

    if (date <= 0 || date > monthLength[_month - 1]) {
        return false;
    }

    // All checks out!
    return true;
};
